import { Col as BSCol } from "react-bootstrap";

export function Col(props) {

  return <BSCol {...props} />;
}